import { render, staticRenderFns } from "./StreamPlayer copy.vue?vue&type=template&id=09d572da"
import script from "./StreamPlayer copy.vue?vue&type=script&lang=js"
export * from "./StreamPlayer copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports